import React, { memo } from "react";
import PropTypes from "prop-types";
import { Message, useLocales, useMessage } from "react-message-context";
import { Action } from "@op/opds.opux";
import { EN, FI, UNIDENTIFIED } from "../../utils/enums";

const Login = memo((props) => {
  const { customerType } = props;

  const locales = useLocales();
  const lang = locales ? locales[0] : FI;

  const actionLink = useMessage("url.form.person")();

  const renderLoginLink = () => (
    <>
      <br />
      <Action id="CFF-login" href={actionLink}>
        <Message id="login.link" />
      </Action>
    </>
  );

  return (
    <>
      {customerType === UNIDENTIFIED && (
        <p className="cff-login">
          <Message id="login.body" />
          {lang !== EN && renderLoginLink()}
        </p>
      )}
    </>
  );
});

Login.propTypes = {
  customerType: PropTypes.string.isRequired,
};

export default Login;
